import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { RecentSearch, SearchScope } from "@/modules/sales/search/types";

const MAX_ITEMS = 10;
const STORAGE_KEY = "prism-os.sales.recent-searches";

interface RecentSearchesState {
  items: RecentSearch[];
  push: (query: string, scope: SearchScope) => void;
  remove: (query: string) => void;
  clear: () => void;
}

/**
 * Recent searches — Zustand + localStorage (per-browser, per-user emas).
 * Multi-tenant: tenant switch'da store tozalanmaydi (oddiy UX). Kelajakda
 * `tenantId` per-key qo'shilishi mumkin.
 */
export const useRecentSearchesStore = create<RecentSearchesState>()(
  persist(
    (set, get) => ({
      items: [],
      push: (query, scope) => {
        const trimmed = query.trim();
        if (!trimmed) return;
        const existing = get().items.filter(
          (i) => i.query.toLowerCase() !== trimmed.toLowerCase(),
        );
        const next: RecentSearch[] = [
          { query: trimmed, scope, ts: Date.now() },
          ...existing,
        ].slice(0, MAX_ITEMS);
        set({ items: next });
      },
      remove: (query) => {
        set({
          items: get().items.filter(
            (i) => i.query.toLowerCase() !== query.toLowerCase(),
          ),
        });
      },
      clear: () => set({ items: [] }),
    }),
    { name: STORAGE_KEY },
  ),
);
